import { render, staticRenderFns } from "./HostingSummary.vue?vue&type=template&id=542758cc&"
import script from "./HostingSummary.vue?vue&type=script&lang=js&"
export * from "./HostingSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports